import MuiTabs from '@mui/material/Tabs';
/**
 * Pigment [Tabs](https://pigment.customink.com/?path=/docs/components-tabs)
 */
export var Tabs = MuiTabs;
//# sourceMappingURL=Tabs.js.map